import React from 'react';
import { Bug, Terminal, Zap, Info, Trash2 } from 'lucide-react';

const logs = [
    {
        id: 'log001',
        timestamp: '2025-05-01 10:15:23',
        type: 'INFO',
        source: 'Workflow Engine',
        message: 'Started execution of "Procurement Bot"',
    },
    {
        id: 'log002',
        timestamp: '2025-05-01 10:16:01',
        type: 'LLM',
        source: 'Claude 3',
        message: 'Generated response for agent#A102',
    },
    {
        id: 'log003',
        timestamp: '2025-05-01 10:17:45',
        type: 'ERROR',
        source: 'Webhook Processor',
        message: 'Failed to post to /notify-supplier — status 500',
    },
    {
        id: 'log004',
        timestamp: '2025-05-01 10:18:10',
        type: 'TRIGGER',
        source: 'Schedule Runner',
        message: 'Triggered daily sync for HR Automation',
    },
];
 
const typeColor: Record<string, string> = {
    INFO: 'text-blue-400',
    ERROR: 'text-red-400',
    LLM: 'text-violet-400',
    TRIGGER: 'text-yellow-300',
  };
  

const typeIcon = {
    INFO: <Info className="w-4 h-4" />,
    ERROR: <Bug className="w-4 h-4" />,
    LLM: <Terminal className="w-4 h-4" />,
    TRIGGER: <Zap className="w-4 h-4" />,
};

const Logs = () => {
    return (
        <div>
            {/* Header */}
            <div className="flex justify-between items-center mb-6">
                <div>
                    <h2 className="text-xl font-semibold text-white">Log Streams</h2>
                    <p className="text-sm text-gray-400">Monitor system activity, workflow events, LLM calls, and background jobs.</p>
                </div>
                <button className="text-sm text-red-400 hover:text-red-300 flex items-center">
                    <Trash2 className="w-4 h-4 mr-1" /> Clear Logs
                </button>
            </div>

            {/* Log Table */}
            <div className="overflow-x-auto border border-neutral-800 rounded">
                <table className="min-w-full text-sm text-left text-gray-300">
                    <thead className="bg-neutral-900 text-gray-400">
                        <tr>
                            <th className="px-4 py-2">Timestamp</th>
                            <th className="px-4 py-2">Type</th>
                            <th className="px-4 py-2">Source</th>
                            <th className="px-4 py-2">Message</th>
                        </tr>
                    </thead>
                    <tbody>
                        {logs.map((log) => (
                            <tr key={log.id} className="border-t border-neutral-800 hover:bg-neutral-800/30">
                                <td className="px-4 py-2 font-mono text-xs">{log.timestamp}</td>
                                <td className={`px-4 py-2 font-semibold flex items-center gap-2 ${typeColor[log.type]}`}>
                                    {log.type === 'INFO' && <Info className="w-4 h-4" />}
                                    {log.type === 'ERROR' && <Bug className="w-4 h-4" />}
                                    {log.type === 'LLM' && <Terminal className="w-4 h-4" />}
                                    {log.type === 'TRIGGER' && <Zap className="w-4 h-4" />}
                                    {log.type}
                                </td>
                                <td className="px-4 py-2">{log.source}</td>
                                <td className="px-4 py-2">{log.message}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Logs;
